import { guardClient } from '../_axios'

/**
 * 会社情報の新規追加
 * [post]/company
 */
type Sales = {
  firstName?: string
  lastName: string
  department?: string
  post?: string
  cellPhone?: string
  mail: string
}
export type NewRequestType = {
  name: string
  frequencyCode?: string
  tagCode?: string
  specialty?: string
  specialtyIndustry?: string
  postCode?: string
  address?: string
  homePhone?: string
  homepage?: string
  establishment?: string
  invoice?: string
  salesValue?: number
  properValue?: number
  bpValue?: number
  deliverAddress?: string
  dispatchLicense?: boolean
  dispatchLicenseNumber?: number
  pMark?: boolean
  isms?: boolean
  memo?: string
  focusCustomer?: boolean
  sales: Sales[]
}
export const insertCompany = async (request: NewRequestType) => {
  const path = '/company'
  const { ...params } = request
  return await guardClient.post(path, params)
}
